<template>
    <ModalFormCard :action="'/actions/crm-refill-auto-remove/' + this.subscription.id" class="modal-default lg:!w-[500px]">
        <template #title>Remove refill plan</template>

        <template #default="{ saving, errors }">
            <p class="text-14">Remove your refill plan and cancel future automatic payments</p>

            <div class="bg-grey-300 px-6 py-3 mt-4">
                <p class="font-semibold text-15">Good to know</p>
                <p class="text-grey-900 text-14">
                    If you forget to manually refill and your balance drops to zero, some of Zapo CRM’s main features will stop working.
                </p>
            </div>

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black h-12 default !text-13">Remove refill plan</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    data() {
        return {
            amounts: [
                { value: 10, html: this.$help.dp(10) },
                { value: 25, html: this.$help.dp(25) },
                { value: 50, html: this.$help.dp(50) },
                { value: 75, html: this.$help.dp(75) },
                { value: 100, html: this.$help.dp(100) },
            ],
            value: {
                card_id: this.editingModel.crm_auto_refill_card_id,
                amount: this.editingModel.crm_auto_refill_amount,
            },
        }
    },

    methods: {
        showRemove() {
            this.$event.$emit('modal-open', {
                view: 'CrmAutoFillRemove',
                editingModel: this.editingModel,
            })
        },
    },

    computed: {
        subscription() {
            return this.editingModel
        },
    },
}
</script>
